import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "container" };
const _hoisted_2 = { class: "row mb-2" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "col-4" }, " Name ", -1);
const _hoisted_4 = { class: "col-8" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("hr", null, null, -1);
const _hoisted_6 = { class: "col-4" };
const _hoisted_7 = { class: "col-8" };
import useRooms from '@/compositions/useRooms';
import { SchedulePrioritySelector } from '@/components/Schedule';
import { cloneDeep } from 'lodash';
import { ref, watch } from 'vue';
import { SchedulePriority } from '@/types/rooms';
export default /*#__PURE__*/ _defineComponent({
    props: {
        modelValue: null
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: emits }) {
        const props = __props;
        const { rooms } = useRooms();
        const localTemplate = ref(cloneDeep(props.modelValue));
        const updateDefaultRoomPreferences = () => {
            console.log('here');
            Object.keys(rooms.value).forEach(roomId => {
                if (localTemplate.value.room_preferences[roomId] === undefined) {
                    localTemplate.value.room_preferences[roomId] = SchedulePriority.Never;
                }
            });
        };
        watch(props.modelValue, updateDefaultRoomPreferences, { immediate: true, deep: true });
        watch(rooms, updateDefaultRoomPreferences, { immediate: true, deep: true });
        watch(localTemplate, (value) => {
            emits('update:modelValue', value);
        }, { deep: true });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createElementVNode("div", _hoisted_4, [
                        _withDirectives(_createElementVNode("input", {
                            class: "form-control",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((localTemplate.value.name) = $event)),
                            type: "text"
                        }, null, 512), [
                            [_vModelText, localTemplate.value.name]
                        ])
                    ])
                ]),
                _hoisted_5,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_unref(rooms)), ([id, room]) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: "row mb-2",
                        key: id
                    }, [
                        _createElementVNode("div", _hoisted_6, _toDisplayString(room.name), 1),
                        _createElementVNode("div", _hoisted_7, [
                            _createVNode(_unref(SchedulePrioritySelector), {
                                modelValue: localTemplate.value.room_preferences[id],
                                "onUpdate:modelValue": ($event) => ((localTemplate.value.room_preferences[id]) = $event)
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ])
                    ]));
                }), 128))
            ]));
        };
    }
});
